/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free percent solution calculator. Enter any two of mass, volume and percent (w/v) to solve the third. Mix mass and volume units freely.`)
};

const es_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de solución porcentual. Introduce dos de los tres valores (masa, volumen y porcentaje p/v) para calcular el tercero. Combina unidades de masa y volumen libremente.`)
};

const de_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Prozentlösungsrechner. Geben Sie zwei von Masse, Volumen und Prozent (w/v) ein, um die dritte Größe zu berechnen. Massen- und Volumeneinheiten können frei gemischt werden.`)
};

const nl_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis procentuele oplossingscalculator. Vul twee van de drie waarden in — massa, volume en percentage (g/v) — om de derde te berekenen. Massa- en volume-eenheden vrij te combineren.`)
};

const fr_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de solution en pourcentage. Entrez deux valeurs parmi la masse, le volume et le pourcentage (p/v) pour résoudre la troisième. Mélangez librement les unités de masse et de volume.`)
};

const it_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di soluzioni percentuali. Inserisci due qualsiasi tra massa, volume e percentuale (p/v) per risolvere il terzo. Unità di massa e volume liberamente combinabili.`)
};

const pt_br2_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de solução percentual. Informe dois dos três valores — massa, volume e percentual (p/v) — para resolver o terceiro. Misture unidades de massa e volume livremente.`)
};

const pt_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de solução percentual. Introduza quaisquer dois valores entre massa, volume e percentagem (m/v) para calcular o terceiro. Misture unidades de massa e volume livremente.`)
};

const ja_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のパーセント溶液計算ツール。質量、体積、パーセント (w/v) のうち2つを入力すると、残り1つを計算します。質量と体積の単位は自由に混在できます。`)
};

const zh_pctsol_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费百分比溶液计算器。输入质量、体积和百分比（w/v）中任意两项，求解第三项。质量和体积单位可自由混用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_meta_description", locale)
	if (locale === "en") return en_pctsol_meta_description(inputs)
	if (locale === "es") return es_pctsol_meta_description(inputs)
	if (locale === "de") return de_pctsol_meta_description(inputs)
	if (locale === "nl") return nl_pctsol_meta_description(inputs)
	if (locale === "fr") return fr_pctsol_meta_description(inputs)
	if (locale === "it") return it_pctsol_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_meta_description(inputs)
	if (locale === "pt") return pt_pctsol_meta_description(inputs)
	if (locale === "ja") return ja_pctsol_meta_description(inputs)
	return zh_pctsol_meta_description(inputs)
};